var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownLong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 29,
    viewBox: "0 0 8 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.76168 28.3536C3.95694 28.5488 4.27352 28.5488 4.46879 28.3536L7.65077 25.1716C7.84603 24.9763 7.84603 24.6597 7.65077 24.4645C7.4555 24.2692 7.13892 24.2692 6.94366 24.4645L4.11523 27.2929L1.28681 24.4645C1.09154 24.2692 0.774962 24.2692 0.579699 24.4645C0.384437 24.6597 0.384437 24.9763 0.579699 25.1716L3.76168 28.3536ZM3.61523 -2.12506e-08L3.61523 28L4.61523 28L4.61523 2.12506e-08L3.61523 -2.12506e-08Z",
    fill: "#CED4DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownLong);
export default __webpack_public_path__ + "static/media/arrow-down-long.c27e0f4e.svg";
export { ForwardRef as ReactComponent };